import React from "react";
import {
  formatPreviewTestType,
  formatPreviewTestSpec,
  formatMrlCountriesListSubtitleFromEditorShape,
  filterSpecManagerProductsBySearch,
  filterSpecManagerLocationsBySearch,
  mapEnvLocationToProductShape,
  getTestSpecEntityLabels,
  SPEC_TYPE,
} from "../utils/utils";
import { SpecStatusChip } from "../shared/specManagerUi";
import SelectedProductList from "../shared/SelectedProductList";
import "./TestSpecPreviewStep.css";

export default function TestSpecPreviewStep({
  testName,
  specRow,
  selectedProducts,
  identifierFields,
  searchValue,
  specType = SPEC_TYPE.PRODUCT,
}) {
  const entityLabels = getTestSpecEntityLabels(specType);
  const hasMrl = Array.isArray(specRow.countries_lst) && specRow.countries_lst.length > 0;
  const testTypeValue = formatPreviewTestType(specRow);
  const specValueLabel = hasMrl
    ? formatMrlCountriesListSubtitleFromEditorShape(specRow.countries_lst)
    : formatPreviewTestSpec(specRow);

  let filteredProducts = selectedProducts;
  if (specType === SPEC_TYPE.ENVIRONMENT) {
    filteredProducts = filterSpecManagerLocationsBySearch(
      selectedProducts,
      searchValue,
      identifierFields,
    ).map((locationRow) => mapEnvLocationToProductShape(locationRow, identifierFields));
  } else {
    filteredProducts = filterSpecManagerProductsBySearch(
      selectedProducts,
      searchValue,
      identifierFields,
    );
  }

  return (
    <div className="TestSpecPreview_Root">
      <div className="TestSpecPreview_BodyScroll">
        <div className="TestSpecPreview_DetailsBox">
          <div className="TestSpecPreview_DetailsMain">
            <div className="TestSpecPreview_TestName" title={testName}>{testName}</div>
            <div className="TestSpecPreview_MetaLine">
              <span>
                <strong>Test Type:</strong>
                {" "}
                {testTypeValue}
              </span>
              <span className="TestSpecPreview_Bullet">•</span>
              <span>
                <strong>Test Spec:</strong>
                {" "}
                {specValueLabel}
              </span>
            </div>
          </div>
          <SpecStatusChip status="added" variant="overview" />
        </div>

        <div className="TestSpecPreview_ProductsArea">
          <div className="TestSpecPreview_ProductsTitle">
            {entityLabels.selectedPreviewTitle}
            {" ("}
            {selectedProducts.length}
            )
          </div>
          <SelectedProductList
            products={filteredProducts}
            identifierFields={identifierFields}
            loading={false}
            readOnly
            specType={specType}
          />
        </div>
      </div>
    </div>
  );
}
